<template>
  <div>
    <main class="container-fluid">
      <div class="row heading">
        <div class="col-4 px-3 pt-3 d-none d-md-flex"></div>
        <div class="col-16 px-3 pt-3">
          <h1 class="title pt-2 mb-0" v-text="$ml.get('progTimelineTitle')">
            Programas Timeline!
          </h1>
          <h1 class="title">
            <span class="pb-2" v-text="$ml.get('progTimelineSubTitle')"
              >Acompanhe a timeline dos seus programas</span
            >
          </h1>
        </div>
      </div>
      <section class="row">
        <div class="col-4 px-3 pb-3"></div>

        <!-- Inicio do filtro-mobile -->
        <b-sidebar
          ref="sidebarFilter"
          id="sidebar-filter"
          no-header
          backdrop-variant="dark"
          backdrop
          shadow
          width="220px"
        >
          <div class="card-header d-flex justify-content-between">
            <a>Filtro</a>
            <a
              class="row justify-content-start pointer"
              @click="closeSidebarFilter"
              role="button"
            >
              <img
                src="../../../../src/assets/icons/times-circle.svg"
                class="ico-15"
              />
            </a>
          </div>

          <div class="card card-body pt-2 pl-0">
            <aside>
              <ul class="none-p-m">
                <li class="pb-2">
                  <a v-text="$ml.get('type')"> Tipo </a>
                  <ul class="none-p-m pt-2 pb-3">
                    <li :class="this.type == '' ? 'active py-1' : 'py-1'">
                      <i
                        ><img
                          src="../../../../src/assets/icons/angle-right.svg"
                          class="ico-16 mb-1"
                      /></i>
                      <a
                        @click="(type = ''), changeProgram()"
                        v-text="$ml.get('all')"
                      >
                        Todos
                      </a>
                    </li>
                    <li
                      :class="this.type == 'private' ? 'active py-1' : 'py-1'"
                    >
                      <i
                        ><img
                          src="../../../../src/assets/icons/angle-right.svg"
                          class="ico-16 mb-1"
                      /></i>
                      <a
                        @click="(type = 'private'), changeProgram()"
                        v-text="$ml.get('private')"
                      >
                        Privados
                      </a>
                    </li>
                    <li :class="this.type == 'public' ? 'active py-1' : 'py-1'">
                      <i
                        ><img
                          src="../../../../src/assets/icons/angle-right.svg"
                          class="ico-16 mb-1"
                      /></i>
                      <a
                        @click="(type = 'public'), changeProgram()"
                        v-text="$ml.get('public')"
                      >
                        Públicos
                      </a>
                    </li>
                    <li :class="this.type == 'vdp' ? 'active py-1' : 'py-1'">
                      <i
                        ><img
                          src="../../../../src/assets/icons/angle-right.svg"
                          class="ico-16 mb-1"
                      /></i>
                      <a
                        @click="(type = 'vdp'), changeProgram()"
                        v-text="'VDP'"
                      >
                        VDP
                      </a>
                    </li>
                  </ul>
                </li>
                <li class="pb-2">
                  <a v-text="$ml.get('reward')"> Recompensa </a>
                  <ul class="none-p-m pt-2 pb-3">
                    <li :class="this.reward == '' ? 'active py-1' : 'py-1'">
                      <i
                        ><img
                          src="../../../../src/assets/icons/angle-right.svg"
                          class="ico-16 mb-1"
                      /></i>
                      <a
                        @click="(reward = ''), changeProgram()"
                        v-text="$ml.get('bounty')"
                      >
                        Todos
                      </a>
                    </li>
                    <li
                      :class="this.reward == 'bounty' ? 'active py-1' : 'py-1'"
                    >
                      <i
                        ><img
                          src="../../../../src/assets/icons/angle-right.svg"
                          class="ico-16 mb-1"
                      /></i>
                      <a
                        @click="(reward = 'bounty'), changeProgram()"
                        v-text="$ml.get('bounty')"
                      >
                        Financeira
                      </a>
                    </li>
                    <li :class="this.reward == 'gift' ? 'active py-1' : 'py-1'">
                      <i
                        ><img
                          src="../../../../src/assets/icons/angle-right.svg"
                          class="ico-16 mb-1"
                      /></i>
                      <a
                        @click="(reward = 'gift'), changeProgram()"
                        v-text="$ml.get('giftsAndAcknowledgments')"
                      >
                        Brindes e Agradecimentos
                      </a>
                    </li>
                  </ul>
                </li>

                <li class="pb-2">
                  <a v-text="$ml.get('time')"> Tempo </a>
                  <ul class="none-p-m pt-2 pb-3">
                    <li :class="this.period == '' ? 'active py-1' : 'py-1'">
                      <i
                        ><img
                          src="../../../../src/assets/icons/angle-right.svg"
                          class="ico-16 mb-1"
                      /></i>
                      <a
                        @click="(period = ''), changeProgram()"
                        v-text="$ml.get('all')"
                      >
                        Todos
                      </a>
                    </li>
                    <li
                      :class="
                        this.period == 'last_day' ? 'active py-1' : 'py-1'
                      "
                    >
                      <i
                        ><img
                          src="../../../../src/assets/icons/angle-right.svg"
                          class="ico-16 mb-1"
                      /></i>
                      <a
                        @click="(period = 'last_day'), changeProgram()"
                        v-text="$ml.get('oneDayAgo')"
                      >
                        há um dia
                      </a>
                    </li>
                    <li
                      :class="
                        this.period == 'last_week' ? 'active py-1' : 'py-1'
                      "
                    >
                      <i
                        ><img
                          src="../../../../src/assets/icons/angle-right.svg"
                          class="ico-16 mb-1"
                      /></i>
                      <a
                        @click="(period = 'last_week'), changeProgram()"
                        v-text="$ml.get('thisWeek')"
                      >
                        nesta semana
                      </a>
                    </li>
                    <li
                      :class="
                        this.period == 'last_month' ? 'active py-1' : 'py-1'
                      "
                    >
                      <i
                        ><img
                          src="../../../../src/assets/icons/angle-right.svg"
                          class="ico-16 mb-1"
                      /></i>
                      <a
                        @click="(period = 'last_month'), changeProgram()"
                        v-text="$ml.get('lessThanMonthAgo')"
                      >
                        há menos de um mês
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </aside>
          </div>
        </b-sidebar>

        <a
          id="btn-float-mobile"
          class="d-md-none btn"
          v-b-toggle.sidebar-filter
          role="button"
        >
          <svg width="20" height="20" class="mb-1">
            <image
              xlink:href="../../../../src/assets/icons/search.svg"
              width="20"
              height="20"
            />
          </svg>
        </a>
        <!-- Fim -->

        <div class="col-4 pb-3 d-none d-md-flex">
          <aside class="col">
            <ul class="none-p-m">
              <li class="pb-2">
                <a v-text="$ml.get('type')"> Tipo </a>
                <ul class="none-p-m pt-2 pb-3">
                  <li :class="this.type == '' ? 'active py-1' : 'py-1'">
                    <i
                      ><img
                        src="../../../../src/assets/icons/angle-right.svg"
                        class="ico-16 mb-1"
                    /></i>
                    <a
                      @click="(type = ''), changeProgram()"
                      v-text="$ml.get('all')"
                    >
                      Todos
                    </a>
                  </li>
                  <li :class="this.type == 'private' ? 'active py-1' : 'py-1'">
                    <i
                      ><img
                        src="../../../../src/assets/icons/angle-right.svg"
                        class="ico-16 mb-1"
                    /></i>
                    <a
                      @click="(type = 'private'), changeProgram()"
                      v-text="$ml.get('private')"
                    >
                      Privados
                    </a>
                  </li>
                  <li :class="this.type == 'public' ? 'active py-1' : 'py-1'">
                    <i
                      ><img
                        src="../../../../src/assets/icons/angle-right.svg"
                        class="ico-16 mb-1"
                    /></i>
                    <a
                      @click="(type = 'public'), changeProgram()"
                      v-text="$ml.get('public')"
                    >
                      Públicos
                    </a>
                  </li>
                  <li :class="this.type == 'vdp' ? 'active py-1' : 'py-1'">
                    <i
                      ><img
                        src="../../../../src/assets/icons/angle-right.svg"
                        class="ico-16 mb-1"
                    /></i>
                    <a @click="(type = 'vdp'), changeProgram()" v-text="'VDP'">
                      VDP
                    </a>
                  </li>
                </ul>
              </li>
              <li class="pb-2">
                <a v-text="$ml.get('reward')"> Recompensa </a>
                <ul class="none-p-m pt-2 pb-3">
                  <li :class="this.reward == '' ? 'active py-1' : 'py-1'">
                    <i
                      ><img
                        src="../../../../src/assets/icons/angle-right.svg"
                        class="ico-16 mb-1"
                    /></i>
                    <a
                      @click="(reward = ''), changeProgram()"
                      v-text="$ml.get('all')"
                    >
                      Todos
                    </a>
                  </li>
                  <li :class="this.reward == 'bounty' ? 'active py-1' : 'py-1'">
                    <i
                      ><img
                        src="../../../../src/assets/icons/angle-right.svg"
                        class="ico-16 mb-1"
                    /></i>
                    <a
                      @click="(reward = 'bounty'), changeProgram()"
                      v-text="$ml.get('bounty')"
                    >
                      Financeira
                    </a>
                  </li>
                </ul>
              </li>
              <li class="pb-2">
                <a v-text="$ml.get('features')"> Funcionalidades </a>
                <ul class="none-p-m pt-2 pb-3">
                  <li :class="this.vpn == true ? 'active py-1' : 'py-1'">
                    <i
                      ><img
                        src="../../../../src/assets/icons/angle-right.svg"
                        class="ico-16 mb-1"
                    /></i>
                    <a
                      @click="(vpn = !vpn)"
                    >
                      VPN
                    </a>
                  </li>

                  <li :class="this.nda == true ? 'active py-1' : 'py-1'">
                    <i
                      ><img
                        src="../../../../src/assets/icons/angle-right.svg"
                        class="ico-16 mb-1"
                    /></i>
                    <a
                      @click="(nda = !nda)"
                      v-text="$ml.get('protectedByNDA')"
                    >
                      NDA
                    </a>
                  </li>

                  <li :class="this.managed == true ? 'active py-1' : 'py-1'">
                    <i
                      ><img
                        src="../../../../src/assets/icons/angle-right.svg"
                        class="ico-16 mb-1"
                    /></i>
                    <a
                      @click="(managed = !managed)"
                      v-text="$ml.get('managedProgram')"
                    >
                      Managed
                    </a>
                  </li>

                  <li :class="this.credential == true ? 'active py-1' : 'py-1'">
                    <i
                      ><img
                        src="../../../../src/assets/icons/angle-right.svg"
                        class="ico-16 mb-1"
                    /></i>
                    <a
                      @click="(credential = !credential)"
                      v-text="$ml.get('credentialsTooltip')"
                    >
                      Credenciais Disponíveis
                    </a>
                  </li>

                  <li :class="this.campaign == true ? 'active py-1' : 'py-1'">
                    <i
                      ><img
                        src="../../../../src/assets/icons/angle-right.svg"
                        class="ico-16 mb-1"
                    /></i>
                    <a
                      @click="(campaign = !campaign)"
                      v-text="$ml.get('cBoostedProgram')"
                    >
                      Progama inpulsionado
                    </a>
                  </li>

                </ul>
              </li>
              <li class="pb-2">
                <a v-text="$ml.get('time')"> Tempo </a>
                <ul class="none-p-m pt-2 pb-3">
                  <li :class="this.period == '' ? 'active py-1' : 'py-1'">
                    <i
                      ><img
                        src="../../../../src/assets/icons/angle-right.svg"
                        class="ico-16 mb-1"
                    /></i>
                    <a
                      @click="(period = ''), changeProgram()"
                      v-text="$ml.get('all')"
                    >
                      Todos
                    </a>
                  </li>
                  <li
                    :class="this.period == 'last_day' ? 'active py-1' : 'py-1'"
                  >
                    <i
                      ><img
                        src="../../../../src/assets/icons/angle-right.svg"
                        class="ico-16 mb-1"
                    /></i>
                    <a
                      @click="(period = 'last_day'), changeProgram()"
                      v-text="$ml.get('oneDayAgo')"
                    >
                      há um dia
                    </a>
                  </li>
                  <li
                    :class="this.period == 'last_week' ? 'active py-1' : 'py-1'"
                  >
                    <i
                      ><img
                        src="../../../../src/assets/icons/angle-right.svg"
                        class="ico-16 mb-1"
                    /></i>
                    <a
                      @click="(period = 'last_week'), changeProgram()"
                      v-text="$ml.get('thisWeek')"
                    >
                      nesta semana
                    </a>
                  </li>
                  <li
                    :class="
                      this.period == 'last_month' ? 'active py-1' : 'py-1'
                    "
                  >
                    <i
                      ><img
                        src="../../../../src/assets/icons/angle-right.svg"
                        class="ico-16 mb-1"
                    /></i>
                    <a
                      @click="(period = 'last_month'), changeProgram()"
                      v-text="$ml.get('lessThanMonthAgo')"
                    >
                      há menos de um mês
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </aside>
        </div>

        <div class="col-24 col-md-12 px-3 pb-3 mb-5">
          <div class="col d-column">
            <div class="card mb-3">
              <div class="card-body">
                <div class="loading d-flex">
                  <div v-if="loading" class="c-loader"></div>
                  <h6
                    v-else
                    v-show="!itensProgram.length"
                    class="p-1"
                    v-text="$ml.get('noProgramAvailable')"
                  >
                    Nenhum programa disponível
                  </h6>
                </div>

                <div
                  v-for="(item, index) in itensProgram"
                  :key="index"
                  @click="detailPush(item._id)"
                  class="d-column flex-row pt-2"
                >
                  <div
                    :class="
                      'h-profile h-profile-lg d-flex flex-column py-1 align-items-start pointer ' +
                      (index + 1 == itensProgram.length ? 'no' : '')
                    "
                  >
                    <div
                      class="d-flex align-self-start flex-column align-items-start w-100"
                    >
                      <div
                        class="d-flex align-self-start flex-row align-items-start justify-content-start w-100"
                      >
                        <div style="width: 72px">
                          <object
                            width="62"
                            height="62"
                            class="rounded-circle img-lg"
                            :data="item.avatar"
                            type="image/png"
                          >
                            <img
                              width="62"
                              height="62"
                              class="rounded-circle img-lg"
                              src="../../../assets/images/default.png"
                              alt="Avatar"
                            />
                          </object>
                        </div>

                        <div class="d-flex ml-2 w-100">
                          <div class="align-self-start mt-1 w-100">
                            <h3>
                              <a class="link-block"
                                ><strong v-text="item.name"></strong
                              ></a>
                            </h3>
                            <p class="d-flex align-items-center">
                              <span
                                class="align-self-center"
                                v-text="
                                  $ml
                                    .with(
                                      $utils.formatData(
                                        item.createdAt,
                                        $ml.get('ln')
                                      )
                                    )
                                    .get('publishedDaysAgo')
                                "
                                >Submetido há *</span
                              >
                            </p>
                            <div class="actions mt-2 d-flex flex-row">
                              <VueCustomTooltip :label="$ml.get('ccpProgPriv')">
                                <span
                                  v-if="item.type == 'private'"
                                  class="ico ico-locked mr-1"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Programa Privado"
                                >
                                  <img
                                    src="../../../../src/assets/icons/lock.svg"
                                    class="ico-13"
                                  />
                                </span>
                              </VueCustomTooltip>
                              <VueCustomTooltip
                                :label="$ml.get('credentialsTooltip')"
                              >
                                <span
                                  v-if="
                                    item.type == 'private' && item.credential
                                  "
                                  class="ico ico-credential mr-1"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                >
                                  <img
                                    src="../../../../src/assets/icons/key-fill.svg"
                                    class="ico-18"
                                  />
                                </span>
                              </VueCustomTooltip>
                              <VueCustomTooltip
                                label="Vulnerability Disclosure Program"
                              >
                                <span
                                  v-if="item.type == 'vdp'"
                                  class="ico ico-locked ico-vdp mr-1"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Programa Privado"
                                >
                                  VDP
                                </span>
                              </VueCustomTooltip>
                              <VueCustomTooltip
                                :label="$ml.get('ccpProgPubli')"
                              >
                                <span
                                  v-if="item.type == 'public'"
                                  class="ico ico-locked mr-1"
                                >
                                  <img
                                    src="../../../../src/assets/icons/unlock.svg"
                                    class="ico-13"
                                  />
                                </span>
                              </VueCustomTooltip>
                              <VueCustomTooltip :label="$ml.get('target')">
                                <span
                                  v-if="item.target"
                                  class="ico ico-vpn mr-1"
                                >
                                  <img
                                    src="../../../assets/icons/target-icon.svg"
                                  />
                                </span>
                              </VueCustomTooltip>
                              <VueCustomTooltip
                                :label="$ml.get('managedProgram')"
                                class="mr-1"
                              >
                                <span
                                  v-if="item.managed"
                                  class="ico ico-managed"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Gerenciado pela BugHunt"
                                >
                                  <img
                                    src="../../../assets/images/bughunt.svg"
                                  />
                                </span>
                              </VueCustomTooltip>
                              <VueCustomTooltip
                                :label="$ml.get('protectedByNDA')"
                              >
                                <span
                                  v-if="item.program_nda"
                                  class="ico ico-nda mr-1"
                                >
                                  <img
                                    src="../../../assets/icons/security-shield.svg"
                                  />
                                </span>
                              </VueCustomTooltip>
                              <VueCustomTooltip label="VPN">
                                <span
                                  v-if="item.vpn_required"
                                  class="ico ico-vpn mr-1"
                                >
                                  <img src="../../../assets/images/vpn.png" />
                                </span>
                              </VueCustomTooltip>
                              <VueCustomTooltip
                                :label="$ml.get('doubleReward')"
                              >
                                <span
                                  v-if="
                                    item.campaign_situation == 'in_progress'
                                  "
                                  class="ico ico-double mr-1"
                                >
                                  <img
                                    v-if="
                                      item.offers_double_bounty == true &&
                                      item.offers_double_score == true
                                    "
                                    src="../../../assets/icons/icon-diamante.svg"
                                  />
                                  <img
                                    v-else-if="
                                      item.offers_double_bounty == true &&
                                      item.offers_double_score == false
                                    "
                                    src="../../../assets/icons/icon-double-reward.svg"
                                  />
                                  <img
                                    v-else-if="
                                      item.offers_double_bounty == false &&
                                      item.offers_double_score == true
                                    "
                                    src="../../../assets/icons/icon-star.svg"
                                  />
                                </span>
                              </VueCustomTooltip>
                              <ScoreMultiplierIcon v-if="item.offers_bonus_score" :bonus-score-value="item.bonus_score_value" />
                            </div>
                            <hr />
                            <div class="card-chart-body w-100">
                              <div class="row mb-2">
                                <div class="col-8 border-r-d">
                                  <span v-text="$ml.get('reports')"
                                    >Relatórios</span
                                  >
                                  <h6>
                                    <a>{{ item.totalReports }}</a>
                                  </h6>
                                </div>
                                <div class="col-8 border-r-d pl-3">
                                  <span v-text="$ml.get('scope')">Escopo</span>
                                  <h6>{{ item.totalScopes }}</h6>
                                </div>
                                <div class="col-8 pl-3">
                                  <span class="pb-1" v-text="$ml.get('rewards')"
                                    >Recompensas</span
                                  >
                                  <div class="row">
                                    <span
                                      class="pr-2 d-flex align-items-center"
                                      v-if="item.offers_bounty"
                                    >
                                      <div v-if="!item.target" class="d-flex align-items-center">
                                        <span v-if="item?.currency.toUpperCase() === 'BRL'" class="currency">R$</span>
                                        <span v-else class="currency">$</span>
                                        <font>{{$ml.get(item?.currency.toUpperCase())}}</font>
                                      </div>
          
                                      <div v-if="item.target" class='d-flex align-items-center' style="gap:5px" >
                                        <div class='d-flex align-items-center'  v-for="(currency, index) in item.currency" :key="index">
                                          <span v-if="currency === 'BRL'" class="currency">R$</span>
                                          <span v-else class="currency">$</span>
                                          <font >{{ $ml.get(currency.toUpperCase())}}</font>
                                        </div>
                                      </div>
                                    </span>
                                    <span
                                      class="d-flex align-items-center"
                                      v-if="item.offers_gift"
                                    >
                                      <img
                                        src="../../../../src/assets/icons/gift.svg"
                                        class="ico-13 mr-1"
                                      />
                                      <font v-text="$ml.get('gift')"
                                        >Brinde</font
                                      >
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="totalPages > 10 && !loading" class="p-3">
                <b-pagination
                  v-model="pageActive"
                  :total-rows="totalPages"
                  :per-page="pageSize"
                  :prev-text="$ml.get('previous')"
                  :next-text="$ml.get('next')"
                  align="right"
                >
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import ProgramService from "../../../services/program.service";
import ScoreMultiplierIcon from '../../../components/ScoreMultiplierIcon';

export default {
  components: {
    ScoreMultiplierIcon
  },
  data() {
    return {
      itensProgram: [],
      pageActive: 1,
      pageSize: 10,
      totalPages: 0,
      reward: "",
      type: "",
      period: "",
      loading: true,
      nda: null,
      vpn: null,
      managed: null,
      credential: null,
      campaign: null,
    };
  },
  watch: {
    pageActive: function () {
      this.changeProgram();
    },
    nda() {
      this.changeProgram();
    },
    vpn() {
      this.changeProgram();
    },
    managed() {
      this.changeProgram();
    },
    credential() {
      this.changeProgram();
    },
    campaign() {
      this.changeProgram();
    },
  },
  mounted() {
    this.changeProgram();
  },

  methods: {
    closeSidebarFilter() {
      this.$refs.sidebarFilter.hide();
    },

    detailPush(id) {
      this.$router.push(`/program/detail?${id}`);
    },
    changeProgram() {
      this.closeSidebarFilter();
      this.itensProgram = [];
      this.loading = true;
      ProgramService.getProgramList(
        this.pageActive,
        10,
        this.reward,
        this.type,
        this.period,
        this.nda,
        this.vpn,
        this.managed,
        this.credential,
        this.campaign,
      ).then(
        (response) => {
          this.loading = false;
          this.itensProgram = response.data.items;
          this.totalPages = response.data.total;
        },
        () => {
          this.loading = false;
        }
      );
    },
  },
};
</script>
<style scoped>
.active {
  color: #e10e71 !important;
}
.active > a {
  font-weight: 500;
}
a {
  cursor: pointer;
}
a:active {
  color: #e10e71 !important;
}

hr {
  margin-top: 0.9rem;
  margin-bottom: 0.9rem;
}
.custom-control-input:checked ~ .custom-control-label::before {
  border-color: RGB(0, 123, 255) !important;
  background-color: #e10e71;
}
.currency {
  font-weight: 500;
  margin-right: 3px;
}
</style>
